import { useQuery } from "@tanstack/react-query";
import { getGoogleBusinessProfileCategories } from "../../api/bReviewsApi";

export const useGetGoogleBusinessProfileCategories = (params, enabled = true) => {
  return useQuery({
    queryKey: [
      "google-business-profile-categories",
      params.organisationId,
      params.locationId,
      params.regionCode,
      params.languageCode,
      params.search,
    ],
    queryFn: () => getGoogleBusinessProfileCategories(params),
    enabled:
      Boolean(params.organisationId) &&
      Boolean(params.locationId) &&
      Boolean(params.regionCode) &&
      enabled,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
};
